import React, { useState, useRef, useEffect } from 'react';
import { TileGroup, Tile, Checkbox, Button, Search } from 'carbon-components-react';
import { Close16 as Close } from '@carbon/icons-react';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import DataTable from "assets/image/DataTable.svg";
import AreaChart from "assets/image/AreaChart.svg";
import DonutChart from "assets/image/DonutChart.svg";
import GaugeChart from "assets/image/GaugeChart.svg";
import GroupedBarChart from "assets/image/GroupedBarChart.svg";
import LineChart from "assets/image/LineChart.svg";
import SimpleBarChart from "assets/image/SimpleBarChart.svg";
import Summary from "assets/image/Summary.svg";
import StackedBarChart from "assets/image/StackedBarChart.svg";

import DataTableBlue from "assets/image/DataTableBlue.svg";
import AreaChartBlue from "assets/image/AreaChartBlue.svg";
import DonutChartBlue from "assets/image/DonutChartBlue.svg";
import GaugeChartBlue from "assets/image/GaugeChartBlue.svg";
import GroupedBarChartBlue from "assets/image/GroupedBarChartBlue.svg";
import LineChartBlue from "assets/image/LineChartBlue.svg";
import SimpleBarChartBlue from "assets/image/SimpleBarChartBlue.svg";
import SummaryBlue from "assets/image/SummaryBlue.svg";
import StackedBarChartBlue from "assets/image/StackedBarChartBlue.svg";
import * as workspaces from '../../config/WorkspaceConstants';
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import i18n from "../../i18n";
import kpiConfig from "./KpiConfig";
import './HomeScreen.scss';

export default function ManageKPIs(props) {
    let filteredArr = useRef([]);
    let automationKpis = kpiConfig[workspaces.automation_ops].kpis;
    let sapKpis = kpiConfig[workspaces.sap_ops].kpis;
    let salesforceKpis = kpiConfig[workspaces.salesforce_ops].kpis;

    const incidentAnalysis = i18n.t('homepage.incidentAnalysis');
    const responseSLA = i18n.t('homepage.responseSLA');
    const automataSuccessRate = i18n.t('homepage.automataSuccessRate');
    const incidentsSummary = i18n.t('homepage.incidentsSummary');

    useEffect(() => {
        setRemoveItemList([]);
    }, [props.dashboardFilterSelectionsAutomation, props.dashboardFilterSelectionsSAP, props.timeFilterSelections, props.dashboardFilterSelectionsSalesforce])

    let kpiData = [
        {
            incidentManagementKpi: [
                {
                    id: 'IncidentAnalysis',
                    title: incidentAnalysis,
                    image: SimpleBarChart,
                    selectedKpiImage: SimpleBarChartBlue,
                    defaultChecked: true
                },
                {
                    id: 'IncidentSummary',
                    title: incidentsSummary,
                    image: StackedBarChart,
                    selectedKpiImage: StackedBarChartBlue,
                    defaultChecked: true
                },
                {
                    id: 'FirtsTimeResolution',
                    title: DashboardConstants.FirsttimeResolution,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'IncidentAgeing',
                    title: DashboardConstants.IncidentAgeingSLAReport,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'ResponseAndResolutionSLAMet',
                    title: responseSLA,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: true
                }
            ],
            alertManagementKpi: [
                {
                    id: 'AlertVsIncidentTrend',
                    title: DashboardConstants.AlertVsIncidentTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: true
                },
                {
                    id: 'IcrAndNoiseReduction',
                    title: DashboardConstants.IncidentConversionRatioNoiseReduction,
                    image: Summary,
                    selectedKpiImage: SummaryBlue,
                    defaultChecked: false
                },
                {
                    id: 'AlertClassification',
                    title: DashboardConstants.AlertClassification,
                    image: Summary,
                    selectedKpiImage: SummaryBlue,
                    defaultChecked: false
                },
                {
                    id: 'AlertDistribution',
                    title: DashboardConstants.AlertDistribution,
                    image: AreaChart,
                    selectedKpiImage: AreaChartBlue,
                    defaultChecked: false
                },

                {
                    id: 'LoginTrend',
                    title: DashboardConstants.LoginTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: true
                },
                {
                    id: 'UserLoginTopFailures',
                    title: DashboardConstants.UserLoginTopfailures,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'BatchJobsTrend',
                    title: DashboardConstants.BatchJobTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'BatchJobsTopFailures',
                    title: DashboardConstants.BatchJobFailures,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },

                {
                    id: 'IntegrationTrend',
                    title: DashboardConstants.IntegrationTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'IntegrationTopFailures',
                    title: DashboardConstants.IntegrationTopFailures,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },

                {
                    id: 'AbandonedProcessesTrend',
                    title: DashboardConstants.AbandonedProcessesTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'AbandonedTopFailures',
                    title: DashboardConstants.AbandonedProcessesFailures,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                }

            ],
            automataManagementKpi: [
                {
                    id: 'SuccessTerminationTrend',
                    title: DashboardConstants.SuccessAndTerminationTrend,
                    image: LineChart,
                    selectedKpiImage: LineChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'SuccessRate',
                    title: automataSuccessRate,
                    image: GaugeChart,
                    selectedKpiImage: GaugeChartBlue,
                    defaultChecked: true
                },
                {
                    id: 'ResourceLiveStatus',
                    title: DashboardConstants.RsourceLiveStatus,
                    image: 'Description of the Kpi',
                    defaultChecked: false
                },
                {
                    id: 'SelfHeal',
                    title: DashboardConstants.SelfHeal,
                    image: 'Description of the Kpi',
                    defaultChecked: false
                },
                {
                    id: 'ProductivityMetrics',
                    title: DashboardConstants.ProductivityMetrics,
                    image: Summary,
                    selectedKpiImage: SummaryBlue,
                    defaultChecked: false
                },
                {
                    id: 'QueueStatistics',
                    title: DashboardConstants.QueueStatistics,
                    image: DataTable,
                    selectedKpiImage: DataTableBlue,
                    defaultChecked: false
                },
                {
                    id: 'QueuePerformance',
                    title: DashboardConstants.QueuePerformance,
                    image: DataTable,
                    selectedKpiImage: DataTableBlue,
                    defaultChecked: false
                },
                {
                    id: 'LongRunningAutomataList',
                    title: DashboardConstants.TopLongRunningAutomtaList,
                    image: GroupedBarChart,
                    selectedKpiImage: GroupedBarChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'ExceptionClassification',
                    title: DashboardConstants.ExceptionClassification,
                    image: DonutChart,
                    selectedKpiImage: DonutChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'SchedulingEfficiency',
                    title: DashboardConstants.SchedulingEfficiency,
                    image: Summary,
                    selectedKpiImage: SummaryBlue,
                    defaultChecked: false
                },
                {
                    id: 'AutomataStartsOnTimeTrend',
                    title: DashboardConstants.AutomationStartsOnTimeTrend,
                    image: GaugeChart,
                    selectedKpiImage: GaugeChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'AutomataRunsOnTimeTrend',
                    title: DashboardConstants.AutomationRunsOnTimeTrend,
                    image: GaugeChart,
                    selectedKpiImage: GaugeChartBlue,
                    defaultChecked: false
                },
                // {
                //     id: 'TerminationReasons',
                //     title: DashboardConstants.TopTerminationReasons,
                //     image: DataTable,
                //     selectedKpiImage: DataTableBlue,
                //     defaultChecked: false
                // },
                {
                    id: 'FirstTimeSuccessfulRun',
                    title: DashboardConstants.FirstTimeSuccessfulRun,
                    image: SimpleBarChart,
                    selectedKpiImage: SimpleBarChartBlue,
                    defaultChecked: false
                },
                {
                    id: 'BotSummaryReport',
                    title: DashboardConstants.BotSummaryReport,
                    image: DataTable,
                    selectedKpiImage: DataTableBlue,
                    defaultChecked: false
                },
                {
                    id: 'QueueAverage',
                    title: DashboardConstants.QueueAverageHandling,
                    image: DataTable,
                    selectedKpiImage: DataTableBlue,
                    defaultChecked: false
                }
            ]
        }
    ]
    const [searchIncidentTerm, setSearchIncidentTerm] = useState("");
    const [searchAlertTerm, setSearchAlertTerm] = useState("");
    const [searchAutomataTerm, setSearchAutomataTerm] = useState("");
    const [searchIncidentResults, setSearchIncidentResults] = useState(kpiData);
    const [searchAlertResults, setSearchAlertResults] = useState(kpiData);
    const [searchAutomataResults, setSearchAutomataResults] = useState(kpiData);
    //const [checkItem, setCheckItem] = useState(false);
    const [removeItemList, setRemoveItemList] = useState([]);
    const [checkedStatus, setCheckedStatus] = useState(true);
    const [showKpi, setShowKpi] = useState(false);

    useEffect(() => {
        if (searchIncidentTerm.length > 0) {
            if (searchIncidentTerm.length === searchAlertTerm.length && searchIncidentTerm.length === searchAutomataTerm.length) {
                return;
            }
            else if ((searchIncidentTerm.length === searchAlertTerm.length)) {
                setSearchAutomataResults([]);
            }
            else if ((searchIncidentTerm.length === searchAutomataTerm.length)) {
                setSearchAlertResults([]);
            }
            else {
                setSearchAutomataResults([]);
                setSearchAlertResults([]);
            }
        }
    }, [searchIncidentTerm]);

    useEffect(() => {
        if (searchIncidentTerm.length === searchAlertTerm.length && searchIncidentTerm.length === searchAutomataTerm.length) {
            return;
        }
        else if (searchAlertTerm.length > 0) {
            if ((searchAlertTerm.length === searchAutomataTerm.length)) {
                setSearchIncidentResults([]);
            }
            else if ((searchIncidentTerm.length === searchAlertTerm.length)) {
                setSearchAutomataResults([]);
            }
            else {
                setSearchAutomataResults([]);
                setSearchIncidentResults([]);
            }
        }
    }, [searchAlertTerm]);

    useEffect(() => {
        if (searchIncidentTerm.length === searchAlertTerm.length && searchIncidentTerm.length === searchAutomataTerm.length) {
            return;
        }
        else if (searchAutomataTerm.length > 0) {
            if ((searchAlertTerm.length === searchAutomataTerm.length)) {
                setSearchIncidentResults([]);
            }
            else if ((searchIncidentTerm.length === searchAutomataTerm.length)) {
                setSearchAlertResults([]);
            }
            else {
                setSearchAlertResults([]);
                setSearchIncidentResults([]);
            }
        }
    }, [searchAutomataTerm])

    const handleSearch = (e) => {
        let value = e.target.value ? e.target.value.toString() : '';

        kpiData.map((kpiItem) => {
            let searchArr = [], incidentArr = [];
            let incidentkpi = kpiItem.incidentManagementKpi;
            incidentkpi.map((incidentKpi, i) => {
                let title = incidentKpi.title.toLowerCase();
                if (title.includes(value.toLowerCase())) {
                    let incidentObj = {
                        id: incidentKpi.id,
                        title: incidentKpi.title,
                        image: incidentKpi.image,
                        selectedKpiImage: incidentKpi.selectedKpiImage,
                        defaultChecked: incidentKpi.defaultChecked
                    }
                    incidentArr.push(incidentObj);
                }

            });
            let filtObj = {
                incidentManagementKpi: incidentArr
            }
            searchArr.push(filtObj);
            filteredArr.current = searchArr;
            if (searchArr.length > 0) {
                setSearchIncidentResults(searchArr);
                setSearchIncidentTerm(value);
            }
        });
        kpiData.map((kpiItem) => {
            let searchArr = [], alertArr = [];
            let alertkpi = kpiItem.alertManagementKpi;
            alertkpi.map((alertkpi, i) => {
                let title = alertkpi.title.toLowerCase();
                if (title.includes(value.toLowerCase())) {
                    let alertObj = {
                        id: alertkpi.id,
                        title: alertkpi.title,
                        image: alertkpi.image,
                        selectedKpiImage: alertkpi.selectedKpiImage,
                        defaultChecked: alertkpi.defaultChecked
                    }
                    alertArr.push(alertObj);
                }
            });
            let filtObj = {
                alertManagementKpi: alertArr
            }
            searchArr.push(filtObj);
            filteredArr.current = searchArr;
            if (searchArr.length > 0) {
                setSearchAlertResults(searchArr);
                setSearchAlertTerm(value);
            }
        });
        kpiData.map((kpiItem) => {
            let searchArr = [], automataArr = [];
            let automatakpi = kpiItem.automataManagementKpi;
            automatakpi.map((automatakpi, i) => {
                let title = automatakpi.title.toLowerCase();
                if (title.includes(value.toLowerCase())) {

                    let automataObj = {
                        id: automatakpi.id,
                        title: automatakpi.title,
                        image: automatakpi.image,
                        selectedKpiImage: automatakpi.selectedKpiImage,
                        defaultChecked: automatakpi.defaultChecked
                    }
                    automataArr.push(automataObj);
                }
            });

            let filtObj = {
                automataManagementKpi: automataArr
            }
            searchArr.push(filtObj);
            filteredArr.current = searchArr;
            if (searchArr.length > 0) {
                setSearchAutomataResults(searchArr);
                setSearchAutomataTerm(value);
            }
        });

    };

    useEffect(() => { checkedStatus === false && props.onRemoveItem(removeItemList); }, [removeItemList, checkedStatus]);

    const handleReset = e => {
        setSearchIncidentTerm("");
        setSearchAlertTerm("");
        setSearchAutomataTerm("");
        setSearchIncidentResults(kpiData);
        setSearchAutomataResults(kpiData);
        setSearchAlertResults(kpiData);
    }

    const handleChange = (e, name) => {
        if (e) {
            setCheckedStatus(true)
            props.onAddItem(name);
            setRemoveItemList(removeItemList.filter(item => name !== item));
        } else {
            let removeItemArr = [];
            removeItemArr = name;
            setCheckedStatus(e);
            setRemoveItemList([...removeItemList, removeItemArr])
        }
    };

    const populateInitialCheckedItems = (kpi) => {
        let kpiItems = props.items;
        return kpiItems.includes(kpi.id) ? true : false;
    }

    return (
        <div>
            <div className="manage-kpis">
                <div className="title-section">
                    <div className="title">{DashboardConstants.AddRemoveKPIs}</div>
                    <div>
                        <Button
                            renderIcon={Close}
                            hasIconOnly
                            kind="ghost"
                            onClick={() => { props.handleShowKpi(!showKpi) }}
                        />
                    </div>
                </div>
                <div className="searchBar">
                    <Search
                        size="sm"
                        labelText="Search"
                        closeButtonLabelText="Clear search input"
                        id="search-1"
                        onChange={handleSearch}
                        onClear={handleReset}
                    />
                </div>
                <div style={{ marginRight: '10px' }}>
                    <TileGroup>
                        {searchIncidentResults.map((kpiItem) => {
                            let incidentkpi = kpiItem.incidentManagementKpi;
                            let incidentArr = [];
                            if (props.workspace === workspaces.automation_ops) {
                                for (let i = 0; i < incidentkpi.length; i++) {
                                    for (let j = 0; j < automationKpis.length; j++) {
                                        if (incidentkpi[i].id === automationKpis[j]) {
                                            let incArr = incidentkpi.filter((item) => item.id === automationKpis[j]);
                                            incidentArr.push(incArr[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.sap_ops) {
                                for (let i = 0; i < incidentkpi.length; i++) {
                                    for (let j = 0; j < sapKpis.length; j++) {
                                        if (incidentkpi[i].id === sapKpis[j]) {
                                            let incArr = incidentkpi.filter((item) => item.id === sapKpis[j]);
                                            incidentArr.push(incArr[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.salesforce_ops) {
                                for (let i = 0; i < incidentkpi.length; i++) {
                                    for (let j = 0; j < salesforceKpis.length; j++) {
                                        if (incidentkpi[i].id === salesforceKpis[j]) {
                                            let incArr = incidentkpi.filter((item) => item.id === salesforceKpis[j]);
                                            incidentArr.push(incArr[0]);
                                        }
                                    }
                                }
                            }
                            return (
                                searchIncidentResults.length !== 0 && incidentArr.length > 0 ?
                                    <div className="kpi-tiles">
                                        <div className="incident-kpi">
                                            <div className="kpi-group">{DashboardConstants.IncidentManagementKPIs}</div>
                                            {incidentArr && incidentArr.map((incidentKpi) => {
                                                return (
                                                    <div>
                                                        <Tile>
                                                            <div className="kpi-section">
                                                                <div className="image_icon">
                                                                    <ListItemAvatar><img src={populateInitialCheckedItems(incidentKpi) === true ? incidentKpi.selectedKpiImage : incidentKpi.image} /></ListItemAvatar>
                                                                </div>
                                                                <div className="kpi-header bx--col-lg-13">
                                                                    <div className="kpi-title">{incidentKpi.title}</div>
                                                                </div>
                                                                <Checkbox
                                                                    id={Math.random()}
                                                                    checked={populateInitialCheckedItems(incidentKpi)}
                                                                    onChange={(e) => { handleChange(e, incidentKpi.id) }}
                                                                />
                                                                {/* <div className="kpi-description">{incidentKpi.details}</div> */}
                                                            </div>
                                                        </Tile>
                                                        <hr className="divider" />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div> : null
                            )
                        })}
                        {searchAlertResults.map((kpiItem) => {
                            let alertkpi = kpiItem.alertManagementKpi;
                            let alertArr = [];
                            if (props.workspace === workspaces.automation_ops) {
                                for (let i = 0; i < alertkpi.length; i++) {
                                    for (let j = 0; j < automationKpis.length; j++) {
                                        if (alertkpi[i].id === automationKpis[j]) {
                                            let alertArray = alertkpi.filter((item) => item.id === automationKpis[j]);
                                            alertArr.push(alertArray[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.sap_ops) {
                                for (let i = 0; i < alertkpi.length; i++) {
                                    for (let j = 0; j < sapKpis.length; j++) {
                                        if (alertkpi[i].id === sapKpis[j]) {
                                            let alertArray = alertkpi.filter((item) => item.id === sapKpis[j]);
                                            alertArr.push(alertArray[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.salesforce_ops) {
                                for (let i = 0; i < alertkpi.length; i++) {
                                    for (let j = 0; j < salesforceKpis.length; j++) {
                                        if (alertkpi[i].id === salesforceKpis[j]) {
                                            let alertArray = alertkpi.filter((item) => item.id === salesforceKpis[j]);
                                            alertArr.push(alertArray[0]);
                                        }
                                    }
                                }
                            }
                            return (
                                searchAlertResults.length !== 0 && alertArr.length > 0 ?
                                    <div className="kpi-tiles">
                                        <div className="alert-kpi">
                                            <div className="kpi-group">{DashboardConstants.AlertManagementKPIs}</div>
                                            {alertArr && alertArr.map((alertkpi) => {
                                                return (
                                                    <div>
                                                        <Tile>
                                                            <div className="kpi-section">
                                                                <div className="image_icon">
                                                                    <ListItemAvatar><img src={populateInitialCheckedItems(alertkpi) === true ? alertkpi.selectedKpiImage : alertkpi.image} /></ListItemAvatar>
                                                                </div>
                                                                <div className="kpi-header bx--col-lg-13">
                                                                    <div className="kpi-title">{alertkpi.title}</div>
                                                                </div>
                                                                <Checkbox
                                                                    id={Math.random()}
                                                                    checked={populateInitialCheckedItems(alertkpi)}
                                                                    onChange={(e) => { handleChange(e, alertkpi.id) }}
                                                                />
                                                                {/* <div className="kpi-description">{alertkpi.details}</div> */}
                                                            </div>
                                                        </Tile>
                                                        <hr className="divider" />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div> : null
                            )
                        })}
                        {searchAutomataResults.map((kpiItem) => {
                            let automatakpi = kpiItem.automataManagementKpi;
                            let automataArr = [];
                            if (props.workspace === workspaces.automation_ops) {
                                for (let i = 0; i < automatakpi.length; i++) {
                                    for (let j = 0; j < automationKpis.length; j++) {
                                        if (automatakpi[i].id === automationKpis[j]) {
                                            let automataArray = automatakpi.filter((item) => item.id === automationKpis[j]);
                                            automataArr.push(automataArray[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.sap_ops) {
                                for (let i = 0; i < automatakpi.length; i++) {
                                    for (let j = 0; j < sapKpis.length; j++) {
                                        if (automatakpi[i].id === sapKpis[j]) {
                                            let automataArray = automatakpi.filter((item) => item.id === sapKpis[j]);
                                            automataArr.push(automataArray[0]);
                                        }
                                    }
                                }
                            }
                            else if (props.workspace === workspaces.salesforce_ops) {
                                for (let i = 0; i < automatakpi.length; i++) {
                                    for (let j = 0; j < salesforceKpis.length; j++) {
                                        if (automatakpi[i].id === salesforceKpis[j]) {
                                            let automataArray = automatakpi.filter((item) => item.id === salesforceKpis[j]);
                                            automataArr.push(automataArray[0]);
                                        }
                                    }
                                }
                            }
                            return (
                                searchAutomataResults.length !== 0 && automataArr.length > 0 ?
                                    <div className="kpi-tiles">
                                        <div className="automata-kpi">
                                            <div className="kpi-group">{DashboardConstants.AutomataManagementKPIs}</div>
                                            {automataArr && automataArr.map((automatakpi) => {
                                                return (
                                                    <div>
                                                        <Tile>
                                                            <div className="kpi-section">
                                                                <div className="image_icon">
                                                                    <ListItemAvatar><img src={populateInitialCheckedItems(automatakpi) === true ? automatakpi.selectedKpiImage : automatakpi.image} /></ListItemAvatar>
                                                                </div>
                                                                <div className="kpi-header bx--col-lg-13">
                                                                    <div className="kpi-title">{automatakpi.title}</div>
                                                                </div>
                                                                <Checkbox
                                                                    id={Math.random()}
                                                                    checked={populateInitialCheckedItems(automatakpi)}
                                                                    onChange={(e) => { handleChange(e, automatakpi.id) }}
                                                                />
                                                                {/* <div className="kpi-description">{automatakpi.details}</div> */}
                                                            </div>
                                                        </Tile>
                                                        <hr className="divider" />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div> : null
                            )
                        })}
                    </TileGroup>
                </div >
            </div >
        </div >
    )
}